module.exports = __webpack_public_path__ + "img/02_DSC7604-min.9afb4685.jpg";